// FilterControl.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import Filter from './Filter';

/**
 * Adapts the <Filter> React component to Mapbox GL's IControl interface
 * (onAdd/onRemove) so it can be mounted as a map control via
 * map.addControl(new FilterControl(options, onInputChange), position).
 */
class FilterControl {
  constructor(options, onInputChange) {
    this.options = options;
    this.onInputChange = onInputChange;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');

    // Create a root and render the component into it
    this.root = ReactDOM.createRoot(this.container);
    this.root.render(<Filter options={this.options} onInputChange={this.onInputChange} />);

    return this.container;
  }

  onRemove() {
    // Clean up on removal. unmountComponentAtNode is the React 17 API and
    // doesn't operate on a root created with createRoot (React 18) — it's
    // a no-op here, silently leaking the tree onAdd mounted.
    this.root.unmount();
    this.map = undefined;
  }
}

export default FilterControl;
